var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/afterpay-info/step1.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg class=\"i-afterpay-process-icon\" id=\"Icons\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\"\n     viewBox=\"0 0 100 100\" style=\"enable-background:new 0 0 100 100;\" xml:space=\"preserve\" aria-hidden=\"true\">\n<style type=\"text/css\">\n    .st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n</style>\n<path class=\"st0\" d=\"M50,69.4c-1.4-0.9-2.8-1.9-4-3c-2.1-1.9-4.5-4.5-4.4-7.4c0-0.6,0.1-1.2,0.4-1.8c0.8-2.2,3.2-3.4,5.5-2.6\n    c1.3,0.5,2.3,1.5,2.7,2.8c0.6-2.3,3-3.6,5.3-2.9c1.3,0.4,2.4,1.4,2.8,2.7c0.2,0.6,0.4,1.1,0.4,1.8c0.1,2.9-2.3,5.5-4.4,7.4\n    c-1.2,1.1-2.6,2.1-4,3\"/>\n<path class=\"st0\" d=\"M34.5,49V31c0-8.5,6.9-15.5,15.5-15.5s15.5,7,15.5,15.5v18\"/>\n<path class=\"st0\" d=\"M74.5,34.5v45.8c0,2.3-1.9,4.2-4.2,4.2H29.7c-2.3,0-4.2-1.9-4.2-4.2V34.5l0,0H74.5L74.5,34.5z\"/>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/afterpay-info/step1.j2"] , dependencies)